import * as React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { useUnleaveBoard } from '../hooks/useUnleaveBoard'

interface ManageInvitationStatusProps {
  boardTitle: string
  boardId: string
  personId: string
  personName: string
  personEmailAddress: string
  personTenantAssociationId: string
  status: string
  onClose: () => any
}

export const ManageInvitationStatus: React.FC<ManageInvitationStatusProps> = props => {
  const [mutate, { loading }] = useUnleaveBoard()

  const perform = async () => {
    if (loading) return
    await mutate({
      variables: {
        ptaId: props.personTenantAssociationId
      }
    })
    setModalOpen(false)
    props.onClose()
  }

  const [modalOpen, setModalOpen] = React.useState(false)

  return (
    <>
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>Grant access to a Vestaboard</DialogTitle>
        <DialogContent dividers>
          Are you sure you would like to make {props.boardTitle} available to {props.personName} (
          {props.personEmailAddress})?
        </DialogContent>
        <DialogActions>
          <Button variant='contained' color='primary' disabled={loading} onClick={() => perform()}>
            Yes
          </Button>
          <Button onClick={() => setModalOpen(false)}>No</Button>
        </DialogActions>
      </Dialog>
      <div>{props.status}</div>
      <Button variant='outlined' onClick={() => setModalOpen(true)}>
        Change
      </Button>
    </>
  )
}
